require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./javascript-algorithms-and-data-structures-regular-expressions-match-characters-that-occur-zero-or-more-times.json") })
        }
      }, "path---javascript-algorithms-and-data-structures-regular-expressions-match-characters-that-occur-zero-or-more-times");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---javascript-algorithms-and-data-structures-regular-expressions-match-characters-that-occur-zero-or-more-times!./.cache/json/javascript-algorithms-and-data-structures-regular-expressions-match-characters-that-occur-zero-or-more-times.json
// module id = 2481
// module chunks = 231608221292675